import React, {
  Context,
  createContext,
  useContext,
  useEffect,
  useState,
} from 'react';
import { useAuthContext } from './Auth';
import { getCompany } from '../components/API/company';
import { IBusiness } from '../Types/business';
import { debounce, GET_STARTED_DATA_KEY } from '../utils';
import mixpanel from '@8fig/mixpanel';

export interface ICompanyContext {
  business: IBusiness;
  setBusiness: (...args) => any;
  getUserCompany: (...args) => any;
}

export const CompanyContext: Context<ICompanyContext> = createContext({
  business: null,
  setBusiness: () => {},
  getUserCompany: () => {},
});

export default function CompanyContextProvider(props) {
  const { signedIn } = useAuthContext();
  const [business, setBusiness] = useState(null);

  const getUserCompany = debounce(
    async () => {
      if (business) return business;
      try {
        const company = await getCompany();
        if (!business) {
          if (!company.sellerStore) {
            const getStartedData = localStorage.getItem(GET_STARTED_DATA_KEY);
            const getStartedDataFormatted = JSON.parse(getStartedData);
            if (getStartedDataFormatted?.platform) {
              company.sellerStore = getStartedDataFormatted?.platform;
            }
          }
          setBusiness(company);
        }
        return business;
      } catch (error) {
        console.log(`Error fetching company info ${error}`);
        setBusiness({});
      }
    },
    300,
    true,
  );

  useEffect(() => {
    setBusiness(null);
  }, [signedIn]);

  useEffect(() => {
    if (business) {
      const { sellerType, sellerStore, influencerId } = business;
      mixpanel.people.set({
        name: business.name,
        'Store type': sellerType,
        Platform: sellerStore,
        Influencer: influencerId,
      });
    }
  }, [business]);

  return (
    <CompanyContext.Provider
      value={{
        business,
        setBusiness,
        getUserCompany,
      }}
    >
      {props.children}
    </CompanyContext.Provider>
  );
}

export const useCompanyContext = () => useContext(CompanyContext);
